import { Utils } from '../../app.base'
import { MsgBox, Vue } from '../../app.vues';

import SwbPayPhaseTplDetail from './PayPhaseTplDetail';
Vue.regist(SwbPayPhaseTplDetail);

export function openPayPhaseTplDetailDlg(id) {
    //
    let theDlg = Vue.$showDialog({
        title: "付款阶段模板 - 详情",
        width: 800,
        height: 750,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<div class = "">' +
        '<swb-pay-phase-tpl-detail :tplId="tplId" ref="swb_pay_phase_tpl_detail"></swb-pay-phase-tpl-detail>' +
        '</div>',
        data: {
            tplId: id
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

import SwbPayPhaseTplSave from './PayPhaseTplSave';
Vue.regist(SwbPayPhaseTplSave);
export function openPayPhaseTplSaveDlg(dlgConfig, callback) {
    let tplId = dlgConfig['tplId'];
    //
    let title = Utils.isNoB(tplId) ? '新增' : '修改';
    let theDlg = Vue.$showDialog({
        title: '付款阶段模板 - ' + title,
        width: 800,
        height: 700,
        showCloseBtn: true,
        template: '<div class = "">' +
        '<swb-pay-phase-tpl-save :tplId="tplId" ref="swb_pay_phase_tpl_save"></swb-pay-phase-tpl-save>' +
        '</div>',
        data: {
            tplId: tplId,
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_pay_phase_tpl_save.getDlgResult();
            if(result != null) {
                if(result.type == 'info') {
                    let payPhaseTpl = result.data;
                    //
                    callback(payPhaseTpl, theDlg);
                } else {
                    MsgBox.warning(result.message);
                }
            }
            return false;
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

import SwbPayPhaseTplItemListForSelect from './PayPhaseTplItemListForSelect';
Vue.regist(SwbPayPhaseTplItemListForSelect);
export function openPayPhaseTplItemListForSelectDlg(dlgConfig, callback) {
    let tplId = dlgConfig['tplId'];
    let checkedIds = dlgConfig['checkedIds'] || [];
    let isShowSelection = dlgConfig['isShowSelection'];
    //
    let theDlg = Vue.$showDialog({
        title: '付款阶段模板项 - 选择',
        width: 800,
        height: 700,
        showCloseBtn: true,
        template: '<div class = "">' +
        '<swb-pay-phase-tpl-item-list-for-select :tplId="tplId" :checkedIds="checkedIds" :isShowSelection="isShowSelection" ref="swb_pay_phase_tpl_item_list_for_select"></swb-pay-phase-tpl-item-list-for-select>' +
        '</div>',
        data: {
            tplId: tplId,
            checkedIds: checkedIds,
            isShowSelection: isShowSelection,
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_pay_phase_tpl_item_list_for_select.getDlgResult();
            if(result != null) {
                if(result.type == 'info') {
                    let payPhaseTplList = result.data;
                    //
                    callback(payPhaseTplList, theDlg);
                } else {
                    MsgBox.warning(result.message);
                }
            }
            return false;
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}
import SwbPayPhaseTplListForSelect from './PayPhaseTplListForSelect';
Vue.regist(SwbPayPhaseTplListForSelect);
export function openPayPhaseTplListForSelectDlg(dlgConfig, callback) {
    let checkedIds = dlgConfig['checkedIds'] || [];
    let isShowSelection = dlgConfig['isShowSelection'];
    //
    let theDlg = Vue.$showDialog({
        title: '付款阶段模板 - 选择',
        width: 900,
        height: 700,
        showCloseBtn: true,
        template: '<div class = "">' +
        '<swb-pay-phase-tpl-list-for-select  :checkedIds="checkedIds" :isShowSelection="isShowSelection" ref="swb_pay_phase_tpl_list_for_select"></swb-pay-phase-tpl-list-for-select>' +
        '</div>',
        data: {
            checkedIds: checkedIds,
            isShowSelection: isShowSelection,
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_pay_phase_tpl_list_for_select.getDlgResult();
            if(result != null) {
                if(result.type == 'info') {
                    let payPhaseTplList = result.data;
                    //
                    callback(payPhaseTplList, theDlg);
                } else {
                    MsgBox.warning(result.message);
                }
            }
            return false;
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/payPhase/showDlg.js
// module id = 247
// module chunks = 0